export const TRANSACTION_URL = 'https://subtruck.magnus.ms/api/v2/transaction/';

export const HEADERS = {
  'Content-Type': 'application/json',
};
